import React from "react";
import useStyles from "./Styles";
import {
  IconButton,
  Grid,
  Box,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

const AboutSidebar = (props) => {
  const classes = useStyles();
  const { onClose, about } = props;
  const [tab] = React.useState("about");
  const { chart } = useSelector((state) => state.central_arizona);

  const metrics = {
    central_arizona_shortage_impacts: [
      { label: "Cuts of Water", value: "1M ac-ft" },
      { label: "Total Colorado River Water Available", value: "Xxx,xxx ac-ft" },
      { label: "Percentage of NIA water", value: "Xx.xx%" },
      { label: "Percentage of M&I water", value: "Xx.xx%" },
      { label: "Percentage of P3 water", value: "Xx.xx%" },
      { label: "Percentage of Indian water", value: "Xx.xx%" },
    ],
    allocations: [
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
    ],
    shortage_impacts_by_community: [
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
    ],
    shortage_impacts_by_sector: [
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
      { label: "Metric Name", value: "Xxx,xxx ac-ft" },
    ],
  };

  // const onChangeTab = (event, value) => {
  //   setTab(value);
  // };

  return (
    <Box p={4} pt={1}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      {/* <Grid item xs={12} className={classes.tabs}>
        {// chart !== "central_arizona_shortage_impacts" && 
        (
          <Tabs
            value={tab}
            onChange={onChangeTab}
            classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
          >
            <Tab
              classes={{
                root: classes.tabInactive,
                selected: classes.tabActive,
              }}
              value="about"
              label="Summary"
              className={classes.startingTab}
            ></Tab>
            <Tab
              classes={{
                root: classes.tabInactive,
                selected: classes.tabActive,
              }}
              value="stats"
              label="Stats"
              className={classes.endingTab}
            ></Tab>
          </Tabs>
        )}
      </Grid> */}
      {tab === "about" ? (
        <Grid item xs={12} className={classes.aboutBox}>
          {chart !== "shortage_impacts_by_sector" ? (
            <>
              <Typography
                variant="h6"
                component="div"
                className={classes.sectionTitle}
              >
                {about.title}
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.sectionContent}
              >
                {about.desc}
              </Typography>
            </>
          ) : (
            <>
              <Typography
                variant="h6"
                component="div"
                className={classes.sectionTitle}
              >
                Summary
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.sectionContent}
              >
                Colorado River water is used for many purposes, including for
                tap water, mining and power generation, for agriculture, for
                aquifer recharge, and for turf facilities such as golf courses,
                schools, parks, HOAs, and cemeteries. These end uses rely on
                Colorado River water of varying{" "}
                <a target='_blank' href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/" rel="noopener noreferrer">
                  priorities
                </a>
                , and may be impacted by shortage disproportionately.
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.sectionContent}
              >
                This Sankey chart imposes different levels of water availability
                in Central Arizona due to shortage onto the current mix of
                Colorado River water end uses and shows how these end purposes
                would be impacted if Colorado River water is not moved around
                between these different uses.
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.sectionContent}
              >
                There is an active market for Colorado River water in Central
                Arizona, and it is expected that during shortage water will move
                to preferred uses through transfers, leases, and exchanges. For
                example, a city that is using its Colorado River water for
                aquifer recharge might trade the water for previously-stored
                aquifer credits so that another city can use the Colorado River
                water for tap water. Water managers in
                Central Arizona are very innovative; it will be interesting to
                watch how they collaborate to ensure needs are met.
              </Typography>
            </>
          )}
          {/*
                                <Typography variant="h6" component="div" className={classes.sectionTitle}>
                                    About the Big River Policy
                                </Typography>
                                <Typography variant="body2" component="p" className={classes.sectionContent}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip ex ea com duis aute irure. <br/><br/> Learn More about this Big River Policy at the Kyl Center website.
                                </Typography>    
                            */}
        </Grid>
      ) : (
        <Grid item xs={12} className={classes.aboutBox}>
          {metrics[chart].map((metric) => (
            <>
              <Typography
                variant="body2"
                component="p"
                className={classes.metricTitle}
              >
                {metric.label}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                className={classes.metricValue}
              >
                {metric.value}
              </Typography>
            </>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AboutSidebar;
